import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: unknown; output: unknown };
  DateTime: { input: string; output: string };
  Decimal: { input: number; output: number };
  Long: { input: number; output: number };
  UUID: { input: string; output: string };
};

export type AddOptionGroupInput = {
  databaseId: Scalars['String']['input'];
  defaultPrice?: InputMaybe<Scalars['Boolean']['input']>;
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
  minChoices?: InputMaybe<Scalars['Int']['input']>;
  parentRootId: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AddOptionLinesInput = {
  databaseId: Scalars['String']['input'];
  /** Parent node id: a Group or a MainProduct root (for default add-on lines). */
  parentGroupId: Scalars['Int']['input'];
  productIds: Array<Scalars['Int']['input']>;
};

export type ApiKeyResponse = {
  __typename: 'ApiKeyResponse';
  createdAt: Scalars['Long']['output'];
  createdByUser: Maybe<Scalars['String']['output']>;
  envs: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  managedByOrganizationId: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Array<KeyValuePairOfStringAndNullableObject>>;
  name: Scalars['String']['output'];
  secret: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Defines when a policy shall be executed. */
export type ApplyPolicy =
  /** After the resolver was executed. */
  | 'AFTER_RESOLVER'
  /** Before the resolver was executed. */
  | 'BEFORE_RESOLVER'
  /** The policy is applied in the validation step before the execution. */
  | 'VALIDATION';

export type Asset = {
  __typename: 'Asset';
  color: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  height: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imagePath: Maybe<Scalars['String']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  nr: Maybe<Scalars['Int']['output']>;
  parent: Maybe<Asset>;
  parentId: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  room: Maybe<Room>;
  roomId: Maybe<Scalars['Int']['output']>;
  seats: Maybe<Scalars['Int']['output']>;
  sort: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  typeId: Maybe<Scalars['Int']['output']>;
  vatType: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
  x: Maybe<Scalars['Int']['output']>;
  y: Maybe<Scalars['Int']['output']>;
};

/**
 * Single input type for both create and update asset operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type AssetInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nr?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
  vatType?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetPaginatedResult = {
  __typename: 'AssetPaginatedResult';
  edges: Maybe<Array<EdgeOfAsset>>;
  nodes: Array<Asset>;
  pageInfo: PageInfo;
};

export type AttachmentInput = {
  content: Scalars['String']['input'];
  /** Embed inline when set (use src="cid:{contentId}" in HTML). */
  contentId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type BillingOptions = {
  __typename: 'BillingOptions';
  billToOrganization: Maybe<Scalars['String']['output']>;
  gln: Maybe<Scalars['String']['output']>;
  withholdBilling: Maybe<Scalars['Boolean']['output']>;
};

export type BillingOptionsInput = {
  billToOrganization?: InputMaybe<Scalars['String']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  withholdBilling?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BtnCategory = {
  __typename: 'BtnCategory';
  app: Maybe<Scalars['String']['output']>;
  btnMappings: Array<BtnMapping>;
  btnTemplate: BtnTemplate;
  btnTemplateId: Scalars['Int']['output'];
  color: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  parent: Maybe<BtnCategory>;
  parentId: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  sort: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
};

/**
 * Single input type for both create and update button category operations.
 * For create: DatabaseId, BtnTemplateId, and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type BtnCategoryInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
};

export type BtnCategoryPaginatedResult = {
  __typename: 'BtnCategoryPaginatedResult';
  edges: Maybe<Array<EdgeOfBtnCategory>>;
  nodes: Array<BtnCategory>;
  pageInfo: PageInfo;
};

export type BtnLayout = {
  __typename: 'BtnLayout';
  app: Maybe<Scalars['String']['output']>;
  btnTemplate: BtnTemplate;
  btnTemplateId: Scalars['Int']['output'];
  colCount: Maybe<Scalars['Int']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  layerCount: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  rowCount: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  type: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update button layout operations.
 * For create: DatabaseId and BtnTemplateId are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type BtnLayoutInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  colCount?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  layerCount?: InputMaybe<Scalars['Int']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BtnLayoutPaginatedResult = {
  __typename: 'BtnLayoutPaginatedResult';
  edges: Maybe<Array<EdgeOfBtnLayout>>;
  nodes: Array<BtnLayout>;
  pageInfo: PageInfo;
};

export type BtnMapping = {
  __typename: 'BtnMapping';
  app: Maybe<Scalars['String']['output']>;
  btnCategory: Maybe<BtnCategory>;
  btnCategoryId: Maybe<Scalars['Int']['output']>;
  btnTemplate: BtnTemplate;
  btnTemplateId: Scalars['Int']['output'];
  btnType: Maybe<Scalars['String']['output']>;
  col: Maybe<Scalars['Int']['output']>;
  color: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  functionType: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  layer: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  product: Maybe<Product>;
  productId: Maybe<Scalars['Int']['output']>;
  row: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  type: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update button mapping operations.
 * For create: DatabaseId and BtnTemplateId are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type BtnMappingInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnCategoryId?: InputMaybe<Scalars['Int']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  btnType?: InputMaybe<Scalars['String']['input']>;
  col?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  functionType?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  layer?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  row?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BtnMappingPaginatedResult = {
  __typename: 'BtnMappingPaginatedResult';
  edges: Maybe<Array<EdgeOfBtnMapping>>;
  nodes: Array<BtnMapping>;
  pageInfo: PageInfo;
};

export type BtnTemplate = {
  __typename: 'BtnTemplate';
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  layoutOrientation: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
};

/**
 * Single input type for both create and update button template operations.
 * For create: DatabaseId is required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type BtnTemplateInput = {
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  layoutOrientation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
};

export type BtnTemplatePaginatedResult = {
  __typename: 'BtnTemplatePaginatedResult';
  edges: Maybe<Array<EdgeOfBtnTemplate>>;
  nodes: Array<BtnTemplate>;
  pageInfo: PageInfo;
};

export type ChangeCreditTokenInput = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  remainingTses?: InputMaybe<Scalars['Int']['input']>;
  validProductTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChangeTseInput = {
  metadata: Scalars['String']['input'];
};

/**
 * Flat DTO for Chart so the POS schema does not expose the entity type
 * and avoids GraphQL type-name collision with Api.Chart in the same assembly.
 */
export type ChartDto = {
  __typename: 'ChartDto';
  createdAt: Scalars['DateTime']['output'];
  dataJson: Maybe<Scalars['String']['output']>;
  databaseId: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  organizationUnitId: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChartInput = {
  chartName?: InputMaybe<Scalars['String']['input']>;
  chartType?: InputMaybe<Scalars['String']['input']>;
  dataJson?: InputMaybe<Scalars['String']['input']>;
  databaseUniqueId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationUnitId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ChartResult = {
  __typename: 'ChartResult';
  nodes: Array<ChartDto>;
};

export type Closing = {
  __typename: 'Closing';
  amount: Maybe<Scalars['Decimal']['output']>;
  appName: Maybe<Scalars['String']['output']>;
  appSerial: Maybe<Scalars['String']['output']>;
  appVersion: Maybe<Scalars['String']['output']>;
  cashCountProtocol: Maybe<Scalars['String']['output']>;
  closingId: Scalars['Int']['output'];
  closingNr: Maybe<Scalars['Int']['output']>;
  databaseId: Scalars['UUID']['output'];
  employeeId: Maybe<Scalars['Int']['output']>;
  employeeName: Maybe<Scalars['String']['output']>;
  employeeNr: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  printData: Maybe<Scalars['String']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  terminalId: Maybe<Scalars['Int']['output']>;
  terminalName: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['DateTime']['output']>;
  timestampOpening: Maybe<Scalars['DateTime']['output']>;
  type: ClosingType;
};

export type ClosingInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appSerial?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  cashCountProtocol?: InputMaybe<Scalars['String']['input']>;
  closingId: Scalars['Int']['input'];
  closingNr?: InputMaybe<Scalars['Int']['input']>;
  databaseId: Scalars['UUID']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  employeeNr?: InputMaybe<Scalars['Int']['input']>;
  printData?: InputMaybe<Scalars['String']['input']>;
  terminalId?: InputMaybe<Scalars['Int']['input']>;
  terminalName?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  timestampOpening?: InputMaybe<Scalars['DateTime']['input']>;
  type: ClosingType;
};

export type ClosingPaginatedResult = {
  __typename: 'ClosingPaginatedResult';
  edges: Maybe<Array<EdgeOfClosing>>;
  nodes: Array<Closing>;
  pageInfo: PageInfo;
};

export type ClosingType = 'DAY' | 'MONTH' | 'YEAR';

export type CloudSyncState = 'SUCCESSFUL' | 'SYNC_FAILED' | 'SYNC_PENDING' | 'UNKNOWN';

export type Company = {
  __typename: 'Company';
  bankBIC: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  bankIBAN: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  country: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  eMail: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  salesTaxId: Maybe<Scalars['String']['output']>;
  salutation: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  taxId: Maybe<Scalars['String']['output']>;
  taxNr: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update company operations.
 * For create: DatabaseId and CompanyName are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type CompanyInput = {
  bankBIC?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankIBAN?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  eMail?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  salesTaxId?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxNr?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyPaginatedResult = {
  __typename: 'CompanyPaginatedResult';
  edges: Maybe<Array<EdgeOfCompany>>;
  nodes: Array<Company>;
  pageInfo: PageInfo;
};

export type CopyProductOptionsTreeInput = {
  databaseId: Scalars['String']['input'];
  sourceRootId: Scalars['Int']['input'];
};

export type CreateCreditTokenInput = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  remainingTses?: InputMaybe<Scalars['Int']['input']>;
  validProductTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateDefaultProductOptionsTreeInput = {
  branchType?: InputMaybe<Scalars['String']['input']>;
  databaseId: Scalars['String']['input'];
};

export type CreateFiskalyApiKeyInput = {
  managedByOrganizationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: Scalars['String']['input'];
};

export type CreateFiskalyOrganizationInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  billingOptions?: InputMaybe<BillingOptionsInput>;
  contactPersonId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  economyId?: InputMaybe<Scalars['String']['input']>;
  managedByOrganizationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  town: Scalars['String']['input'];
  vatId?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreateMainProductOptionsTreeInput = {
  databaseId: Scalars['String']['input'];
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
  minChoices?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSwissbitTseInput = {
  metadata: Scalars['String']['input'];
  productType: Scalars['String']['input'];
};

export type DataOverviewInput = {
  databaseName: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};

export type DataUsageOverview = {
  __typename: 'DataUsageOverview';
  databaseName: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
};

export type DuplicateOptionGroupInput = {
  databaseId: Scalars['String']['input'];
  sourceGroupId: Scalars['Int']['input'];
  targetProductId?: InputMaybe<Scalars['Int']['input']>;
  targetRootId?: InputMaybe<Scalars['Int']['input']>;
};

export type EdgeOfAsset = {
  __typename: 'EdgeOfAsset';
  cursor: Scalars['String']['output'];
  node: Asset;
};

export type EdgeOfBtnCategory = {
  __typename: 'EdgeOfBtnCategory';
  cursor: Scalars['String']['output'];
  node: BtnCategory;
};

export type EdgeOfBtnLayout = {
  __typename: 'EdgeOfBtnLayout';
  cursor: Scalars['String']['output'];
  node: BtnLayout;
};

export type EdgeOfBtnMapping = {
  __typename: 'EdgeOfBtnMapping';
  cursor: Scalars['String']['output'];
  node: BtnMapping;
};

export type EdgeOfBtnTemplate = {
  __typename: 'EdgeOfBtnTemplate';
  cursor: Scalars['String']['output'];
  node: BtnTemplate;
};

export type EdgeOfClosing = {
  __typename: 'EdgeOfClosing';
  cursor: Scalars['String']['output'];
  node: Closing;
};

export type EdgeOfCompany = {
  __typename: 'EdgeOfCompany';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type EdgeOfEmployee = {
  __typename: 'EdgeOfEmployee';
  cursor: Scalars['String']['output'];
  node: Employee;
};

export type EdgeOfIngredient = {
  __typename: 'EdgeOfIngredient';
  cursor: Scalars['String']['output'];
  node: Ingredient;
};

export type EdgeOfPrinter = {
  __typename: 'EdgeOfPrinter';
  cursor: Scalars['String']['output'];
  node: Printer;
};

export type EdgeOfProdCategory = {
  __typename: 'EdgeOfProdCategory';
  cursor: Scalars['String']['output'];
  node: ProdCategory;
};

export type EdgeOfProduct = {
  __typename: 'EdgeOfProduct';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type EdgeOfProductTree = {
  __typename: 'EdgeOfProductTree';
  cursor: Scalars['String']['output'];
  node: ProductTree;
};

export type EdgeOfRoom = {
  __typename: 'EdgeOfRoom';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type EdgeOfSecurityDevice = {
  __typename: 'EdgeOfSecurityDevice';
  cursor: Scalars['String']['output'];
  node: SecurityDevice;
};

export type EdgeOfSecurityTerminal = {
  __typename: 'EdgeOfSecurityTerminal';
  cursor: Scalars['String']['output'];
  node: SecurityTerminal;
};

export type EdgeOfSetting = {
  __typename: 'EdgeOfSetting';
  cursor: Scalars['String']['output'];
  node: Setting;
};

export type EdgeOfTerminal = {
  __typename: 'EdgeOfTerminal';
  cursor: Scalars['String']['output'];
  node: Terminal;
};

export type EdgeOfVat = {
  __typename: 'EdgeOfVat';
  cursor: Scalars['String']['output'];
  node: Vat;
};

export type ElsterReport = {
  __typename: 'ElsterReport';
  createdTime: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  lastModified: Maybe<Scalars['DateTime']['output']>;
  organizationUnitId: Maybe<Scalars['UUID']['output']>;
  parentId: Maybe<Scalars['UUID']['output']>;
  reportJsonData: Maybe<Scalars['String']['output']>;
  reportPdfDataBase64: Maybe<Scalars['String']['output']>;
  reportType: Maybe<Scalars['String']['output']>;
  reportXmlData: Maybe<Scalars['String']['output']>;
  sendTime: Maybe<Scalars['DateTime']['output']>;
  sendUserName: Maybe<Scalars['String']['output']>;
  serverResponseXmlData: Maybe<Scalars['String']['output']>;
  serverReturnXmlData: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  transmissionState: Maybe<ReportTransmissionState>;
  usedShopCreditId: Maybe<Scalars['UUID']['output']>;
  validationErrors: Maybe<Scalars['String']['output']>;
  validationState: Maybe<ReportValidationState>;
};

export type ElsterReportInput = {
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  organizationUnitId?: InputMaybe<Scalars['UUID']['input']>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  reportJsonData?: InputMaybe<Scalars['String']['input']>;
  reportPdfDataBase64?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportXmlData?: InputMaybe<Scalars['String']['input']>;
  sendTime?: InputMaybe<Scalars['DateTime']['input']>;
  sendUserName?: InputMaybe<Scalars['String']['input']>;
  transmissionState?: InputMaybe<ReportTransmissionState>;
  validationErrors?: InputMaybe<Scalars['String']['input']>;
  validationState?: InputMaybe<ReportValidationState>;
};

export type Employee = {
  __typename: 'Employee';
  active: Maybe<Scalars['Boolean']['output']>;
  appPermissions: Maybe<Scalars['String']['output']>;
  areaLocked: Maybe<Scalars['Boolean']['output']>;
  btnTemplate: Maybe<BtnTemplate>;
  btnTemplateId: Maybe<Scalars['Int']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  keyUid: Maybe<Scalars['String']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  nr: Maybe<Scalars['Int']['output']>;
  password: Maybe<Scalars['String']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  printerTemplateId: Maybe<Scalars['Int']['output']>;
  state: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  timeTrackWeekWorkingHours: Maybe<Scalars['Int']['output']>;
  type: Maybe<UserType>;
  userPermissions: Maybe<Scalars['String']['output']>;
  validRooms: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update employee operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type EmployeeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  appPermissions?: InputMaybe<Scalars['String']['input']>;
  areaLocked?: InputMaybe<Scalars['Boolean']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  keyUid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nr?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  printerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  timeTrackWeekWorkingHours?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  userPermissions?: InputMaybe<Scalars['String']['input']>;
  validRooms?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeePaginatedResult = {
  __typename: 'EmployeePaginatedResult';
  edges: Maybe<Array<EdgeOfEmployee>>;
  nodes: Array<Employee>;
  pageInfo: PageInfo;
};

export type FiskalyAtAuthenticateFonResponse = {
  __typename: 'FiskalyATAuthenticateFonResponse';
  authenticationStatus: FiskalyAtAuthenticateFonResponseAuthenticationStatusEnum;
  fonParticipantId: Scalars['String']['output'];
  fonUserId: Scalars['String']['output'];
  timeAuthentication: Scalars['Long']['output'];
};

export type FiskalyAtAuthenticateFonResponseAuthenticationStatusEnum = 'AUTHENTICATED';

export type FiskalyAtFonAuthenticationStatus =
  | 'AUTHENTICATED'
  | 'ERRORUNSPECIFIED'
  | 'UNAUTHENTICATED';

export type FiskalyAtFonStatusResponse = {
  __typename: 'FiskalyATFonStatusResponse';
  authenticationStatus: FiskalyAtFonAuthenticationStatus;
  fonParticipantId: Maybe<Scalars['String']['output']>;
  fonUserId: Maybe<Scalars['String']['output']>;
  timeAuthentication: Maybe<Scalars['Long']['output']>;
};

export type FiskalyAtFonInput = {
  fonParticipantId: Scalars['String']['input'];
  fonUserId: Scalars['String']['input'];
  fonUserPin: Scalars['String']['input'];
};

/**
 * Single input type for both create and update product operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 * syncState / itemState: send as Int (e.g. CloudSyncState: 0–3, ItemStateMapping: -3 to 1).
 */
export type ImportProductInput = {
  base64Content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
};

export type Ingredient = {
  __typename: 'Ingredient';
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  info: Maybe<Scalars['String']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  posId: Maybe<Scalars['Int']['output']>;
  products: Array<Product>;
  symbol: Maybe<Scalars['String']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  type: Maybe<IngredientType>;
};

/**
 * Single input type for both create and update ingredient operations.
 * For create: DatabaseId, Name, and Type are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type IngredientInput = {
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posId?: InputMaybe<Scalars['Int']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<IngredientType>;
};

export type IngredientPaginatedResult = {
  __typename: 'IngredientPaginatedResult';
  edges: Maybe<Array<EdgeOfIngredient>>;
  nodes: Array<Ingredient>;
  pageInfo: PageInfo;
};

export type IngredientType = 'ADDITIVE' | 'ALLERGEN' | 'TAG';

export type InitializeSecurityDeviceInput = {
  adminPin?: InputMaybe<Scalars['String']['input']>;
  databaseId: Scalars['UUID']['input'];
  deviceType: Scalars['Int']['input'];
  legalEntity?: InputMaybe<LegalEntityInput>;
  licenceSerials: Array<Scalars['String']['input']>;
  serialNr?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KeyValuePairOfStringAndNullableObject = {
  __typename: 'KeyValuePairOfStringAndNullableObject';
  key: Scalars['String']['output'];
  value: Maybe<Scalars['Any']['output']>;
};

export type LegalEntityInput = {
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  legalEntityType: Scalars['String']['input'];
  legalEntityValue: Scalars['String']['input'];
};

export type Mutation = {
  __typename: 'Mutation';
  addAsset: OperationResult;
  addBtnCategory: OperationResult;
  addBtnLayout: OperationResult;
  addBtnMapping: OperationResult;
  addBtnTemplate: OperationResult;
  addCharts: OperationResult;
  addClosings: OperationResult;
  addCompany: OperationResult;
  addElsterReport: OperationResult;
  addEmployee: OperationResult;
  addIngredient: OperationResult;
  addOptionGroup: ProductTree;
  addOptionLines: Array<ProductTree>;
  addPrinter: OperationResult;
  addProdCategory: OperationResult;
  addProduct: OperationResult;
  addRoom: OperationResult;
  addSecurityDevice: OperationResult;
  addSecurityTerminal: OperationResult;
  addSetting: OperationResult;
  addTerminal: OperationResult;
  addVat: OperationResult;
  autofillBtnCategoriesAndMappings: OperationResult;
  changeSwissbitCreditToken: Scalars['Boolean']['output'];
  changeSwissbitTse: Scalars['Boolean']['output'];
  copyProductOptionsTree: OperationResult;
  createDefaultData: OperationResult;
  createDefaultProductOptionsTree: OperationResult;
  createFiskalyApiKey: ApiKeyResponse;
  createFiskalyOrganization: OrganizationResponse;
  createMainProductOptionsTree: ProductTree;
  createSwissbitCreditToken: Maybe<SwissbitCloudBillingCreateCreditTokenResponse>;
  createSwissbitTse: Maybe<Scalars['String']['output']>;
  deleteAssets: OperationResult;
  deleteBtnCategories: OperationResult;
  deleteBtnLayouts: OperationResult;
  deleteBtnMappings: OperationResult;
  deleteBtnTemplates: OperationResult;
  deleteCompanies: OperationResult;
  deleteDataOverviewRows: OperationResult;
  deleteElsterReports: OperationResult;
  deleteEmployees: OperationResult;
  deleteIngredients: OperationResult;
  deleteOptionNode: OperationResult;
  deletePrinters: OperationResult;
  deleteProdCategories: OperationResult;
  deleteProducts: OperationResult;
  deleteRooms: OperationResult;
  deleteSecurityDevices: OperationResult;
  deleteSecurityTerminals: OperationResult;
  deleteSettings: OperationResult;
  deleteSwissbitExport: Scalars['Boolean']['output'];
  deleteTerminals: OperationResult;
  deleteVats: OperationResult;
  deregisterSwissbitClient: Scalars['Boolean']['output'];
  disableSwissbitTse: Scalars['Boolean']['output'];
  duplicateOptionGroup: OperationResult;
  ensureProductOptionsRoot: ProductTree;
  importProducts: OperationResult;
  initializeSecurityDevice: OperationResult;
  processLicence: OperationResult;
  registerSwissbitClient: Scalars['Boolean']['output'];
  saveFiskalyAtFon: Maybe<FiskalyAtAuthenticateFonResponse>;
  sendMail: OperationResult;
  startSwissbitExport: Maybe<SwissbitCloudPosStartExportResponse>;
  terminateSwissbitCreditToken: Scalars['Boolean']['output'];
  updateAsset: OperationResult;
  updateBtnCategory: OperationResult;
  updateBtnLayout: OperationResult;
  updateBtnLayouts: OperationResult;
  updateBtnMapping: OperationResult;
  /** Batch update button mappings for a layout. Handles create, update, and delete (soft or hard by PosId). */
  updateBtnMappings: OperationResult;
  updateBtnTemplate: OperationResult;
  updateCompany: OperationResult;
  updateElsterReport: OperationResult;
  updateEmployee: OperationResult;
  updateIngredient: OperationResult;
  updateOptionNode: OperationResult;
  updatePrinter: OperationResult;
  updateProdCategory: OperationResult;
  updateProduct: OperationResult;
  updateRoom: OperationResult;
  updateSecurityDevice: OperationResult;
  updateSecurityTerminal: OperationResult;
  updateSetting: OperationResult;
  updateSyncState: Scalars['Boolean']['output'];
  updateTerminal: OperationResult;
  updateVat: OperationResult;
  vendorDisableSwissbitTse: Scalars['Boolean']['output'];
};

export type MutationAddAssetArgs = {
  asset: AssetInput;
};

export type MutationAddBtnCategoryArgs = {
  btnCategory: BtnCategoryInput;
};

export type MutationAddBtnLayoutArgs = {
  btnLayout: BtnLayoutInput;
};

export type MutationAddBtnMappingArgs = {
  mapping: BtnMappingInput;
};

export type MutationAddBtnTemplateArgs = {
  btnTemplate: BtnTemplateInput;
};

export type MutationAddChartsArgs = {
  charts: Array<ChartInput>;
};

export type MutationAddClosingsArgs = {
  closings: Array<ClosingInput>;
};

export type MutationAddCompanyArgs = {
  company: CompanyInput;
};

export type MutationAddElsterReportArgs = {
  elsterReport: ElsterReportInput;
};

export type MutationAddEmployeeArgs = {
  employee: EmployeeInput;
};

export type MutationAddIngredientArgs = {
  ingredient: IngredientInput;
};

export type MutationAddOptionGroupArgs = {
  input: AddOptionGroupInput;
};

export type MutationAddOptionLinesArgs = {
  input: AddOptionLinesInput;
};

export type MutationAddPrinterArgs = {
  printer: PrinterInput;
};

export type MutationAddProdCategoryArgs = {
  category: ProdCategoryInput;
};

export type MutationAddProductArgs = {
  product: ProductInput;
};

export type MutationAddRoomArgs = {
  room: RoomInput;
};

export type MutationAddSecurityDeviceArgs = {
  securityDevice: SecurityDeviceInput;
};

export type MutationAddSecurityTerminalArgs = {
  terminal: SecurityTerminalInput;
};

export type MutationAddSettingArgs = {
  setting: SettingInput;
};

export type MutationAddTerminalArgs = {
  terminal: TerminalInput;
};

export type MutationAddVatArgs = {
  vat: VatInput;
};

export type MutationAutofillBtnCategoriesAndMappingsArgs = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['String']['input']>;
  scope: Scalars['String']['input'];
};

export type MutationChangeSwissbitCreditTokenArgs = {
  creditClientId: Scalars['String']['input'];
  input: ChangeCreditTokenInput;
};

export type MutationChangeSwissbitTseArgs = {
  input: ChangeTseInput;
  securityDeviceId: Scalars['Int']['input'];
};

export type MutationCopyProductOptionsTreeArgs = {
  input: CopyProductOptionsTreeInput;
};

export type MutationCreateDefaultDataArgs = {
  appType?: InputMaybe<Scalars['String']['input']>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  databaseId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDefaultProductOptionsTreeArgs = {
  input: CreateDefaultProductOptionsTreeInput;
};

export type MutationCreateFiskalyApiKeyArgs = {
  databaseId: Scalars['UUID']['input'];
  input: CreateFiskalyApiKeyInput;
  organizationId: Scalars['String']['input'];
};

export type MutationCreateFiskalyOrganizationArgs = {
  databaseId: Scalars['UUID']['input'];
  input: CreateFiskalyOrganizationInput;
};

export type MutationCreateMainProductOptionsTreeArgs = {
  input: CreateMainProductOptionsTreeInput;
};

export type MutationCreateSwissbitCreditTokenArgs = {
  databaseId: Scalars['UUID']['input'];
  input: CreateCreditTokenInput;
};

export type MutationCreateSwissbitTseArgs = {
  databaseId: Scalars['UUID']['input'];
  input: CreateSwissbitTseInput;
};

export type MutationDeleteAssetsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteBtnCategoriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteBtnLayoutsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteBtnMappingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteBtnTemplatesArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteCompaniesArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteDataOverviewRowsArgs = {
  databaseId: Scalars['UUID']['input'];
  selectedTables: Array<DataOverviewInput>;
};

export type MutationDeleteElsterReportsArgs = {
  elsterIds: Array<Scalars['UUID']['input']>;
};

export type MutationDeleteEmployeesArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteIngredientsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteOptionNodeArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type MutationDeletePrintersArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteProdCategoriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteProductsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteRoomsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteSecurityDevicesArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteSecurityTerminalsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteSettingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteSwissbitExportArgs = {
  id: Scalars['String']['input'];
  securityDeviceId: Scalars['Int']['input'];
};

export type MutationDeleteTerminalsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteVatsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeregisterSwissbitClientArgs = {
  input: SwissbitClientInput;
  securityDeviceId: Scalars['Int']['input'];
};

export type MutationDisableSwissbitTseArgs = {
  securityDeviceId: Scalars['Int']['input'];
};

export type MutationDuplicateOptionGroupArgs = {
  input: DuplicateOptionGroupInput;
};

export type MutationEnsureProductOptionsRootArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
};

export type MutationImportProductsArgs = {
  importProducts: ImportProductInput;
};

export type MutationInitializeSecurityDeviceArgs = {
  input: InitializeSecurityDeviceInput;
};

export type MutationProcessLicenceArgs = {
  action: Scalars['String']['input'];
  appData: ProcessLicenceInput;
};

export type MutationRegisterSwissbitClientArgs = {
  input: SwissbitClientInput;
  securityDeviceId: Scalars['Int']['input'];
};

export type MutationSaveFiskalyAtFonArgs = {
  databaseId: Scalars['UUID']['input'];
  input: FiskalyAtFonInput;
};

export type MutationSendMailArgs = {
  sendMail: SendMailInput;
};

export type MutationStartSwissbitExportArgs = {
  securityDeviceId: Scalars['Int']['input'];
};

export type MutationTerminateSwissbitCreditTokenArgs = {
  creditClientId: Scalars['String']['input'];
};

export type MutationUpdateAssetArgs = {
  asset: AssetInput;
};

export type MutationUpdateBtnCategoryArgs = {
  btnCategory: BtnCategoryInput;
};

export type MutationUpdateBtnLayoutArgs = {
  btnLayout: BtnLayoutInput;
};

export type MutationUpdateBtnLayoutsArgs = {
  btnLayouts: Array<BtnLayoutInput>;
};

export type MutationUpdateBtnMappingArgs = {
  mapping: BtnMappingInput;
};

export type MutationUpdateBtnMappingsArgs = {
  btnMappings: Array<BtnMappingInput>;
  layout: BtnLayoutInput;
};

export type MutationUpdateBtnTemplateArgs = {
  btnTemplate: BtnTemplateInput;
};

export type MutationUpdateCompanyArgs = {
  company: CompanyInput;
};

export type MutationUpdateElsterReportArgs = {
  elsterReport: ElsterReportInput;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
  validate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateEmployeeArgs = {
  employee: EmployeeInput;
};

export type MutationUpdateIngredientArgs = {
  ingredient: IngredientInput;
};

export type MutationUpdateOptionNodeArgs = {
  input: UpdateOptionNodeInput;
};

export type MutationUpdatePrinterArgs = {
  printer: PrinterInput;
};

export type MutationUpdateProdCategoryArgs = {
  category: ProdCategoryInput;
};

export type MutationUpdateProductArgs = {
  product: ProductInput;
};

export type MutationUpdateRoomArgs = {
  room: RoomInput;
};

export type MutationUpdateSecurityDeviceArgs = {
  securityDevice: SecurityDeviceInput;
};

export type MutationUpdateSecurityTerminalArgs = {
  terminal: SecurityTerminalInput;
};

export type MutationUpdateSettingArgs = {
  setting: SettingInput;
};

export type MutationUpdateSyncStateArgs = {
  databaseId: Scalars['String']['input'];
  syncState: Scalars['Int']['input'];
  tableNames: Array<Scalars['String']['input']>;
};

export type MutationUpdateTerminalArgs = {
  terminal: TerminalInput;
};

export type MutationUpdateVatArgs = {
  vat: VatInput;
};

export type MutationVendorDisableSwissbitTseArgs = {
  tseSerialNumber: Scalars['String']['input'];
};

export type OperationResult = {
  __typename: 'OperationResult';
  cloudId: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  isSuccess: Scalars['Boolean']['output'];
  message: Maybe<Scalars['String']['output']>;
  modelId: Maybe<Scalars['String']['output']>;
  modelObject: Maybe<Scalars['String']['output']>;
  resultValue: Maybe<Scalars['String']['output']>;
  timeStamp: Maybe<Scalars['DateTime']['output']>;
};

/** One row for the "copy group from template" dropdown (type-2 nodes with disambiguation). */
export type OptionGroupTemplate = {
  __typename: 'OptionGroupTemplate';
  mainProductName: Maybe<Scalars['String']['output']>;
  nodeId: Scalars['Int']['output'];
  optionCount: Scalars['Int']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type OrganizationResponse = {
  __typename: 'OrganizationResponse';
  addressLine1: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  billingAddressId: Maybe<Scalars['String']['output']>;
  billingOptions: Maybe<BillingOptions>;
  contactPersonId: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  createdByUser: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  economyId: Maybe<Scalars['String']['output']>;
  envs: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  managedByOrganizationId: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Array<KeyValuePairOfStringAndNullableObject>>;
  name: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  taxNumber: Maybe<Scalars['String']['output']>;
  town: Scalars['String']['output'];
  type: Scalars['String']['output'];
  vatId: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

/**
 * Flat DTO that mirrors the scalar properties of the Billing OrganizationUnit entity.
 * Exposing the entity directly would pull its EF navigation properties (Subscription,
 * Licence, etc.) into the POS schema and cause a GraphQL type-name collision with
 * POS entities such as Product.
 */
export type OrganizationUnitDto = {
  __typename: 'OrganizationUnitDto';
  additionalPropertiesJson: Maybe<Scalars['String']['output']>;
  appType: Maybe<Scalars['String']['output']>;
  branchType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  databaseId: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  sort: Scalars['Int']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationUnitResult = {
  __typename: 'OrganizationUnitResult';
  nodes: Array<OrganizationUnitDto>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedRequestInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Printer = {
  __typename: 'Printer';
  address: Maybe<Scalars['String']['output']>;
  codePage: Maybe<Scalars['Int']['output']>;
  copies: Maybe<Scalars['Int']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  model: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  posId: Maybe<Scalars['Int']['output']>;
  printWidth: Maybe<Scalars['Int']['output']>;
  signals: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  type: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update printer operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type PrinterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  codePage?: InputMaybe<Scalars['Int']['input']>;
  copies?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  printWidth?: InputMaybe<Scalars['Int']['input']>;
  signals?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PrinterPaginatedResult = {
  __typename: 'PrinterPaginatedResult';
  edges: Maybe<Array<EdgeOfPrinter>>;
  nodes: Array<Printer>;
  pageInfo: PageInfo;
};

export type ProcessLicenceApplicationInput = {
  databaseGuid?: InputMaybe<Scalars['String']['input']>;
  debugLevel?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  serialMaster?: InputMaybe<Scalars['String']['input']>;
  targetVersion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessLicenceDeviceInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  hardwareDetails?: InputMaybe<Scalars['String']['input']>;
  iD?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oS?: InputMaybe<Scalars['String']['input']>;
  uID?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessLicenceInput = {
  application: ProcessLicenceApplicationInput;
  device: ProcessLicenceDeviceInput;
  taskUid?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<ProcessLicenceTerminalInput>;
  user?: InputMaybe<ProcessLicenceUserInput>;
};

export type ProcessLicenceTerminalInput = {
  autoLogoff?: InputMaybe<Scalars['Boolean']['input']>;
  buttonTemplate?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  iD?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nr?: InputMaybe<Scalars['Int']['input']>;
  priceGroup?: InputMaybe<Scalars['String']['input']>;
  printerTemplate?: InputMaybe<Scalars['Int']['input']>;
  promotionTemplate?: InputMaybe<Scalars['Int']['input']>;
  vatType?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessLicenceUserInput = {
  iD?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProdCategory = {
  __typename: 'ProdCategory';
  allowedActions: Maybe<Scalars['Int']['output']>;
  color: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  info: Maybe<Scalars['String']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  margin: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  nr: Maybe<Scalars['Int']['output']>;
  parent: Maybe<ProdCategory>;
  parentId: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  printer: Maybe<Printer>;
  printerId: Maybe<Scalars['Int']['output']>;
  prodCategories: Maybe<Array<ProdCategory>>;
  sort: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
};

/**
 * Single input type for both create and update product category operations.
 * For create: DatabaseId, Name, and Type are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type ProdCategoryInput = {
  allowedActions?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  margin?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nr?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  posId?: InputMaybe<Scalars['Int']['input']>;
  printerId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename: 'Product';
  addOn: Maybe<Scalars['Boolean']['output']>;
  baseQty: Maybe<Scalars['Decimal']['output']>;
  baseUnit: Maybe<Scalars['String']['output']>;
  blockDiscount: Maybe<Scalars['Boolean']['output']>;
  buttonMappingUsed: Maybe<Scalars['Boolean']['output']>;
  course: Maybe<Scalars['Int']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  deposit: Maybe<Scalars['Decimal']['output']>;
  descriptionLong: Maybe<Scalars['String']['output']>;
  descriptionShort: Maybe<Scalars['String']['output']>;
  ean: Maybe<Scalars['String']['output']>;
  favorite: Maybe<Scalars['Boolean']['output']>;
  groupBooking: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  info: Maybe<Scalars['String']['output']>;
  ingredientIds: Maybe<Array<Scalars['Int']['output']>>;
  ingredients: Maybe<Array<Ingredient>>;
  ingredientsInfo: Maybe<Scalars['String']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  mainCategory: Maybe<ProdCategory>;
  mainCategoryId: Maybe<Scalars['Int']['output']>;
  margin: Maybe<Scalars['Decimal']['output']>;
  menuId: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  negativePrice: Maybe<Scalars['Boolean']['output']>;
  number: Maybe<Scalars['String']['output']>;
  optionsMenu: Maybe<ProductTree>;
  plu: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  price_A: Maybe<Scalars['Decimal']['output']>;
  price_B: Maybe<Scalars['Decimal']['output']>;
  price_C: Maybe<Scalars['Decimal']['output']>;
  price_D: Maybe<Scalars['Decimal']['output']>;
  price_E: Maybe<Scalars['Decimal']['output']>;
  price_F: Maybe<Scalars['Decimal']['output']>;
  price_G: Maybe<Scalars['Decimal']['output']>;
  price_H: Maybe<Scalars['Decimal']['output']>;
  printer: Maybe<Printer>;
  printerId: Maybe<Scalars['Int']['output']>;
  purchasePrice: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_A: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_B: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_C: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_D: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_E: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_F: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_G: Maybe<Scalars['Decimal']['output']>;
  purchasePrice_H: Maybe<Scalars['Decimal']['output']>;
  scaleArticle: Maybe<Scalars['Boolean']['output']>;
  shopActive: Maybe<Scalars['Boolean']['output']>;
  shopArticle: Maybe<Scalars['Boolean']['output']>;
  shopArticleNr: Maybe<Scalars['String']['output']>;
  stockCount: Maybe<Scalars['Decimal']['output']>;
  stockCountInventory: Maybe<Scalars['Decimal']['output']>;
  stockDisableNegative: Maybe<Scalars['Boolean']['output']>;
  stockReorderCount: Maybe<Scalars['Decimal']['output']>;
  subCategory: Maybe<ProdCategory>;
  subCategoryId: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  unit: Maybe<Scalars['String']['output']>;
  varName: Maybe<Scalars['Boolean']['output']>;
  varNameAppend: Maybe<Scalars['Boolean']['output']>;
  varOptions: Maybe<Scalars['Boolean']['output']>;
  varPrice: Maybe<Scalars['Boolean']['output']>;
  varPriceGroup: Maybe<Scalars['Boolean']['output']>;
  varQty: Maybe<Scalars['Boolean']['output']>;
  varSnr: Maybe<Scalars['Boolean']['output']>;
  vatIn: Maybe<Vat>;
  vatInId: Maybe<Scalars['Int']['output']>;
  vatOut: Maybe<Vat>;
  vatOutId: Maybe<Scalars['Int']['output']>;
};

export type ProductCategoryPaginatedResult = {
  __typename: 'ProductCategoryPaginatedResult';
  edges: Maybe<Array<EdgeOfProdCategory>>;
  nodes: Array<ProdCategory>;
  pageInfo: PageInfo;
};

/**
 * Single input type for both create and update product operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 * syncState / itemState: send as Int (e.g. CloudSyncState: 0–3, ItemStateMapping: -3 to 1).
 */
export type ProductInput = {
  addOn?: InputMaybe<Scalars['Boolean']['input']>;
  blockDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  deposit?: InputMaybe<Scalars['Decimal']['input']>;
  descriptionLong?: InputMaybe<Scalars['String']['input']>;
  descriptionShort?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  ingredientIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  mainCategoryId?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  plu?: InputMaybe<Scalars['Int']['input']>;
  posId?: InputMaybe<Scalars['Int']['input']>;
  price_A?: InputMaybe<Scalars['Decimal']['input']>;
  price_B?: InputMaybe<Scalars['Decimal']['input']>;
  price_C?: InputMaybe<Scalars['Decimal']['input']>;
  price_D?: InputMaybe<Scalars['Decimal']['input']>;
  price_E?: InputMaybe<Scalars['Decimal']['input']>;
  price_F?: InputMaybe<Scalars['Decimal']['input']>;
  price_G?: InputMaybe<Scalars['Decimal']['input']>;
  price_H?: InputMaybe<Scalars['Decimal']['input']>;
  printerId?: InputMaybe<Scalars['Int']['input']>;
  purchasePrice?: InputMaybe<Scalars['Decimal']['input']>;
  scaleArticle?: InputMaybe<Scalars['Boolean']['input']>;
  shopActive?: InputMaybe<Scalars['Boolean']['input']>;
  shopArticle?: InputMaybe<Scalars['Boolean']['input']>;
  subCategoryId?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  varName?: InputMaybe<Scalars['Boolean']['input']>;
  varPrice?: InputMaybe<Scalars['Boolean']['input']>;
  varPriceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  varQty?: InputMaybe<Scalars['Boolean']['input']>;
  vatInId?: InputMaybe<Scalars['Int']['input']>;
  vatOutId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPaginatedResult = {
  __typename: 'ProductPaginatedResult';
  edges: Maybe<Array<EdgeOfProduct>>;
  nodes: Array<Product>;
  pageInfo: PageInfo;
};

export type ProductTree = {
  __typename: 'ProductTree';
  children: Array<ProductTree>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  defaultPrice: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isCopy: Maybe<Scalars['Boolean']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  maxChoices: Maybe<Scalars['Int']['output']>;
  minChoices: Maybe<Scalars['Int']['output']>;
  parentId: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  price_A: Maybe<Scalars['Decimal']['output']>;
  price_B: Maybe<Scalars['Decimal']['output']>;
  price_C: Maybe<Scalars['Decimal']['output']>;
  price_D: Maybe<Scalars['Decimal']['output']>;
  price_E: Maybe<Scalars['Decimal']['output']>;
  price_F: Maybe<Scalars['Decimal']['output']>;
  price_G: Maybe<Scalars['Decimal']['output']>;
  price_H: Maybe<Scalars['Decimal']['output']>;
  product: Maybe<Product>;
  productId: Maybe<Scalars['Int']['output']>;
  sort: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  text: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductTreeType>;
};

export type ProductTreePaginatedResult = {
  __typename: 'ProductTreePaginatedResult';
  edges: Maybe<Array<EdgeOfProductTree>>;
  nodes: Array<ProductTree>;
  pageInfo: PageInfo;
};

export type ProductTreeType =
  | 'ADD_ON'
  | 'DEPRECATED1'
  | 'DEPRECATED2'
  | 'DEPRECATED3'
  | 'DEPRECATED4'
  | 'DEPRECATED5'
  | 'GROUP'
  | 'MAIN_PRODUCT';

export type Query = {
  __typename: 'Query';
  asset: Maybe<Asset>;
  assets: AssetPaginatedResult;
  btnCategories: BtnCategoryPaginatedResult;
  btnCategory: Maybe<BtnCategory>;
  btnLayout: Maybe<BtnLayout>;
  btnLayouts: BtnLayoutPaginatedResult;
  btnMapping: Maybe<BtnMapping>;
  btnMappings: BtnMappingPaginatedResult;
  btnTemplate: Maybe<BtnTemplate>;
  btnTemplates: BtnTemplatePaginatedResult;
  chart: Maybe<ChartDto>;
  charts: ChartResult;
  closings: ClosingPaginatedResult;
  companies: CompanyPaginatedResult;
  company: Maybe<Company>;
  dataUsageOverview: Array<DataUsageOverview>;
  elsterReport: Maybe<ElsterReport>;
  elsterReports: Array<ElsterReport>;
  employee: Maybe<Employee>;
  employees: EmployeePaginatedResult;
  fiskalyAtFonStatus: Maybe<FiskalyAtFonStatusResponse>;
  highestPlu: Maybe<Scalars['Int']['output']>;
  ingredient: Maybe<Ingredient>;
  ingredients: IngredientPaginatedResult;
  ingredientsByProduct: Array<Ingredient>;
  optionGroupTemplates: Array<OptionGroupTemplate>;
  organizationUnits: OrganizationUnitResult;
  printer: Maybe<Printer>;
  printers: PrinterPaginatedResult;
  product: Maybe<Product>;
  productCategories: ProductCategoryPaginatedResult;
  productCategory: Maybe<ProdCategory>;
  productOptionsTree: Maybe<ProductTree>;
  productTrees: ProductTreePaginatedResult;
  products: ProductPaginatedResult;
  room: Maybe<Room>;
  rooms: RoomPaginatedResult;
  securityDevice: Maybe<SecurityDevice>;
  securityDeviceStatus: Maybe<Scalars['String']['output']>;
  securityDevices: SecurityDevicePaginatedResult;
  securityTerminal: Maybe<SecurityTerminal>;
  securityTerminals: SecurityTerminalPaginatedResult;
  setting: Maybe<Setting>;
  settings: SettingPaginatedResult;
  swissbitClients: Maybe<Array<Scalars['String']['output']>>;
  swissbitCreditTokenInfo: Maybe<SwissbitCloudPosCreditTokenInfo>;
  swissbitCreditTokenUsage: Maybe<SwissbitCloudBillingCreditTokenUsageResponse>;
  swissbitCreditTokens: Maybe<Array<SwissbitCloudBillingCreditTokenResponse>>;
  swissbitExportStatus: Maybe<SwissbitCloudPosExportStatusResponse>;
  swissbitExports: Maybe<Array<SwissbitCloudPosExportStatusResponse>>;
  swissbitTseCreationStatus: Maybe<SwissbitCloudPosQueryTseCreationStatusResponse>;
  swissbitTseInfo: Maybe<SwissbitCloudPosInfoResponse>;
  swissbitTsesForCreditToken: Maybe<Array<SwissbitCloudBillingTseVendorItem>>;
  swissbitUsageReport: Maybe<SwissbitUsageReportDashboardResponse>;
  swissbitVendorTseInfo: Maybe<SwissbitCloudBillingInfoVendorResponse>;
  syncState: Array<SyncStateDetails>;
  terminal: Maybe<Terminal>;
  terminals: TerminalPaginatedResult;
  vat: Maybe<Vat>;
  vats: VatPaginatedResult;
};

export type QueryAssetArgs = {
  id: Scalars['Int']['input'];
};

export type QueryAssetsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  tablesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBtnCategoriesArgs = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBtnCategoryArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBtnLayoutArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBtnLayoutsArgs = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
};

export type QueryBtnMappingArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBtnMappingsArgs = {
  app?: InputMaybe<Scalars['String']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
};

export type QueryBtnTemplateArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBtnTemplatesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChartArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  organizationUnitId: Scalars['UUID']['input'];
};

export type QueryClosingsArgs = {
  closingType?: InputMaybe<ClosingType>;
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
};

export type QueryCompaniesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};

export type QueryDataUsageOverviewArgs = {
  databaseId: Scalars['UUID']['input'];
};

export type QueryElsterReportArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  organizationUnitId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryElsterReportsArgs = {
  organizationUnitId?: InputMaybe<Scalars['UUID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEmployeeArgs = {
  id: Scalars['Int']['input'];
};

export type QueryEmployeesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFiskalyAtFonStatusArgs = {
  databaseId: Scalars['UUID']['input'];
};

export type QueryHighestPluArgs = {
  databaseId: Scalars['UUID']['input'];
};

export type QueryIngredientArgs = {
  id: Scalars['Int']['input'];
};

export type QueryIngredientsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IngredientType>;
};

export type QueryIngredientsByProductArgs = {
  databaseId: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type QueryOptionGroupTemplatesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationUnitsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPrinterArgs = {
  id: Scalars['Int']['input'];
};

export type QueryPrintersArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductArgs = {
  id: Scalars['Int']['input'];
};

export type QueryProductCategoriesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductCategoryArgs = {
  id: Scalars['Int']['input'];
};

export type QueryProductOptionsTreeArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type QueryProductTreesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  type?: InputMaybe<ProductTreeType>;
};

export type QueryProductsArgs = {
  addOn?: InputMaybe<Scalars['Boolean']['input']>;
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRoomArgs = {
  id: Scalars['Int']['input'];
};

export type QueryRoomsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySecurityDeviceArgs = {
  id: Scalars['Int']['input'];
};

export type QuerySecurityDeviceStatusArgs = {
  securityDeviceId: Scalars['Int']['input'];
};

export type QuerySecurityDevicesArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySecurityTerminalArgs = {
  id: Scalars['Int']['input'];
};

export type QuerySecurityTerminalsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySettingArgs = {
  id: Scalars['Int']['input'];
};

export type QuerySettingsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySwissbitClientsArgs = {
  securityDeviceId: Scalars['Int']['input'];
};

export type QuerySwissbitCreditTokenInfoArgs = {
  databaseId: Scalars['UUID']['input'];
};

export type QuerySwissbitCreditTokenUsageArgs = {
  creditClientId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type QuerySwissbitExportStatusArgs = {
  id: Scalars['String']['input'];
  securityDeviceId: Scalars['Int']['input'];
};

export type QuerySwissbitExportsArgs = {
  securityDeviceId: Scalars['Int']['input'];
};

export type QuerySwissbitTseCreationStatusArgs = {
  creationId: Scalars['String']['input'];
  databaseId: Scalars['UUID']['input'];
};

export type QuerySwissbitTseInfoArgs = {
  securityDeviceId: Scalars['Int']['input'];
};

export type QuerySwissbitTsesForCreditTokenArgs = {
  creditClientId: Scalars['String']['input'];
};

export type QuerySwissbitUsageReportArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type QuerySwissbitVendorTseInfoArgs = {
  tseSerialNumber: Scalars['String']['input'];
};

export type QuerySyncStateArgs = {
  databaseId: Scalars['String']['input'];
  syncStates?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryTerminalArgs = {
  id: Scalars['Int']['input'];
};

export type QueryTerminalsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVatArgs = {
  id: Scalars['Int']['input'];
};

export type QueryVatsArgs = {
  databaseId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginatedRequestInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTransmissionState = 'DRAFT' | 'ERROR' | 'SEND' | 'UNKNOWN';

export type ReportValidationState = 'NOT_VALIDATED' | 'SUCCESSFULL' | 'VALIDATION_ERRORS';

export type Room = {
  __typename: 'Room';
  assets: Maybe<Array<Asset>>;
  color: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  posId: Maybe<Scalars['Int']['output']>;
  sort: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
};

/**
 * Single input type for both create and update room operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 * Assets: optional; when provided, syncs assets (add new, update existing, remove missing).
 * syncState / itemState: send as Int (e.g. CloudSyncState: 0–3, ItemStateMapping: -3 to 1).
 */
export type RoomInput = {
  assets?: InputMaybe<Array<AssetInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
};

export type RoomPaginatedResult = {
  __typename: 'RoomPaginatedResult';
  edges: Maybe<Array<EdgeOfRoom>>;
  nodes: Array<Room>;
  pageInfo: PageInfo;
};

export type SecurityDevice = {
  __typename: 'SecurityDevice';
  additionalProperties: Maybe<Scalars['String']['output']>;
  adminPin: Maybe<Scalars['String']['output']>;
  backupDate: Maybe<Scalars['DateTime']['output']>;
  backupState: Maybe<Scalars['Int']['output']>;
  bsiCertId: Maybe<Scalars['String']['output']>;
  certificate: Maybe<Scalars['String']['output']>;
  certificateExpirationDate: Maybe<Scalars['DateTime']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  dataEncoding: Maybe<Scalars['String']['output']>;
  databaseId: Scalars['UUID']['output'];
  deviceState: Maybe<Scalars['Int']['output']>;
  deviceType: Maybe<Scalars['Int']['output']>;
  fiskalySecurityData: Maybe<Scalars['String']['output']>;
  formFactor: Maybe<Scalars['String']['output']>;
  fwUpdateAvailable: Maybe<Scalars['String']['output']>;
  hardwareVersion: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  info: Maybe<Scalars['String']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  publicKey: Maybe<Scalars['String']['output']>;
  registeredClients: Maybe<Scalars['String']['output']>;
  remainingSignatures: Maybe<Scalars['Int']['output']>;
  serialNr: Maybe<Scalars['String']['output']>;
  serviceUrl: Maybe<Scalars['String']['output']>;
  sigAlgo: Maybe<Scalars['String']['output']>;
  softwareVersion: Maybe<Scalars['String']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  timeDisabled: Maybe<Scalars['DateTime']['output']>;
  timeEnabled: Maybe<Scalars['DateTime']['output']>;
  timeFormat: Maybe<Scalars['String']['output']>;
  timeLastInit: Maybe<Scalars['DateTime']['output']>;
  timePin: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update security device operations.
 * For create: DatabaseId is required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type SecurityDeviceInput = {
  additionalProperties?: InputMaybe<Scalars['String']['input']>;
  adminPin?: InputMaybe<Scalars['String']['input']>;
  backupDate?: InputMaybe<Scalars['DateTime']['input']>;
  backupState?: InputMaybe<Scalars['Int']['input']>;
  bsiCertId?: InputMaybe<Scalars['String']['input']>;
  certificate?: InputMaybe<Scalars['String']['input']>;
  certificateExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  dataEncoding?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  deviceState?: InputMaybe<Scalars['Int']['input']>;
  deviceType?: InputMaybe<Scalars['Int']['input']>;
  formFactor?: InputMaybe<Scalars['String']['input']>;
  fwUpdateAvailable?: InputMaybe<Scalars['String']['input']>;
  hardwareVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  registeredClients?: InputMaybe<Scalars['String']['input']>;
  remainingSignatures?: InputMaybe<Scalars['Int']['input']>;
  serialNr?: InputMaybe<Scalars['String']['input']>;
  serviceUrl?: InputMaybe<Scalars['String']['input']>;
  sigAlgo?: InputMaybe<Scalars['String']['input']>;
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  timeDisabled?: InputMaybe<Scalars['DateTime']['input']>;
  timeEnabled?: InputMaybe<Scalars['DateTime']['input']>;
  timeFormat?: InputMaybe<Scalars['String']['input']>;
  timeLastInit?: InputMaybe<Scalars['DateTime']['input']>;
  timePin?: InputMaybe<Scalars['String']['input']>;
};

export type SecurityDevicePaginatedResult = {
  __typename: 'SecurityDevicePaginatedResult';
  edges: Maybe<Array<EdgeOfSecurityDevice>>;
  nodes: Array<SecurityDevice>;
  pageInfo: PageInfo;
};

export type SecurityTerminal = {
  __typename: 'SecurityTerminal';
  additionalProperties: Maybe<Scalars['String']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  fiskalyClient: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  info: Maybe<Scalars['String']['output']>;
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  securityDeviceSerialNr: Maybe<Scalars['String']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  terminalSerialNr: Maybe<Scalars['String']['output']>;
  terminalState: Maybe<Scalars['Int']['output']>;
  terminalType: Maybe<Scalars['Int']['output']>;
  timeAdded: Maybe<Scalars['DateTime']['output']>;
  timeLastUsed: Maybe<Scalars['DateTime']['output']>;
  timeRemoved: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Single input type for both create and update security terminal operations.
 * For create: DatabaseId is required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type SecurityTerminalInput = {
  additionalProperties?: InputMaybe<Scalars['String']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  securityDeviceSerialNr?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  terminalSerialNr?: InputMaybe<Scalars['String']['input']>;
  terminalState?: InputMaybe<Scalars['Int']['input']>;
  terminalType?: InputMaybe<Scalars['Int']['input']>;
  timeAdded?: InputMaybe<Scalars['DateTime']['input']>;
  timeLastUsed?: InputMaybe<Scalars['DateTime']['input']>;
  timeRemoved?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SecurityTerminalPaginatedResult = {
  __typename: 'SecurityTerminalPaginatedResult';
  edges: Maybe<Array<EdgeOfSecurityTerminal>>;
  nodes: Array<SecurityTerminal>;
  pageInfo: PageInfo;
};

export type SendMailInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyMappings?: InputMaybe<Array<KeyValueInput>>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['String']['input']>;
  isBodyHtml: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  to: Array<Scalars['String']['input']>;
};

export type Setting = {
  __typename: 'Setting';
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  posId: Maybe<Scalars['String']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  terminal: Maybe<Terminal>;
  terminalId: Maybe<Scalars['Int']['output']>;
  type: SettingType;
  value: Maybe<Scalars['String']['output']>;
};

/**
 * Single input type for both create and update setting operations.
 * For create: DatabaseId is required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 * Note: Setting has PosId as string (unlike other entities where it's int).
 */
export type SettingInput = {
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  posId?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  terminalId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SettingType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SettingPaginatedResult = {
  __typename: 'SettingPaginatedResult';
  edges: Maybe<Array<EdgeOfSetting>>;
  nodes: Array<Setting>;
  pageInfo: PageInfo;
};

export type SettingType = 'GLOBAL' | 'LOCAL';

/** Represents the state of a subscription. */
export type SubscriptionState =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'EXPIRED'
  /** i.e. Created but mandate not yet confirmed (e.g. awaiting billing_request.fulfilled). */
  | 'PENDING'
  | 'SUSPENDED';

export type SwissbitClientInput = {
  clientId: Scalars['String']['input'];
};

export type SwissbitCloudBillingCreateCreditTokenResponse = {
  __typename: 'SwissbitCloudBillingCreateCreditTokenResponse';
  creditClientId: Scalars['String']['output'];
  creditClientSecret: Scalars['String']['output'];
};

export type SwissbitCloudBillingCreditTokenResponse = {
  __typename: 'SwissbitCloudBillingCreditTokenResponse';
  creditClientId: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  remainingTses: Scalars['Int']['output'];
  state: SwissbitCloudBillingCreditTokenState;
  validProductTypes: Array<Scalars['String']['output']>;
};

export type SwissbitCloudBillingCreditTokenState = 'ACTIVE' | 'TERMINATED';

export type SwissbitCloudBillingCreditTokenUsageResponse = {
  __typename: 'SwissbitCloudBillingCreditTokenUsageResponse';
  activeTses: Array<SwissbitCloudBillingTseUsageItem>;
  createdTses: Array<SwissbitCloudBillingTseVendorItem>;
  deactivatedTses: Array<SwissbitCloudBillingTseVendorItem>;
};

export type SwissbitCloudBillingInfoVendorResponse = {
  __typename: 'SwissbitCloudBillingInfoVendorResponse';
  certificateChain: Scalars['String']['output'];
  certificateExpirationDate: Scalars['Int']['output'];
  certificationId: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  createdSignatures: Scalars['Int']['output'];
  creditClientId: Scalars['String']['output'];
  deactivatedAt: Maybe<Scalars['Int']['output']>;
  healthState: SwissbitCloudBillingTseHealthState;
  initializationState: SwissbitCloudBillingTseInitializationState;
  logTimeFormat: Scalars['String']['output'];
  maxRegisteredClients: Scalars['Int']['output'];
  maxStartedTransactions: Scalars['Int']['output'];
  maxUpdateDelay: Scalars['Int']['output'];
  numRegisteredClients: Scalars['Int']['output'];
  numStartedTransactions: Scalars['Int']['output'];
  productType: Scalars['String']['output'];
  productTypeUsage: SwissbitCloudBillingProductTypeUsage;
  publicKey: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  signatureAlgorithm: Scalars['String']['output'];
  softwareVersion: Scalars['String']['output'];
  storageCapacity: Scalars['Int']['output'];
  storageUsed: Scalars['Int']['output'];
  timeUntilNextSelfTest: Scalars['Int']['output'];
};

export type SwissbitCloudBillingProductTypeMode = 'SLOWDOWN' | 'TOP_UP' | 'UNLIMITED';

export type SwissbitCloudBillingProductTypeUsage = {
  __typename: 'SwissbitCloudBillingProductTypeUsage';
  billingPeriodMonths: Scalars['Int']['output'];
  mode: SwissbitCloudBillingProductTypeMode;
  signatureDuration: Scalars['Int']['output'];
  signatureLimit: Maybe<Scalars['Int']['output']>;
  signaturesCurrentMonth: Scalars['Int']['output'];
  signaturesRemainingUntilNextLimit: Maybe<Scalars['Int']['output']>;
  slowdownActive: Maybe<Scalars['Boolean']['output']>;
  slowdownActiveSignatureDuration: Maybe<Scalars['Int']['output']>;
  slowdownInactiveSignatureDuration: Maybe<Scalars['Int']['output']>;
  topUpAmount: Maybe<Scalars['Int']['output']>;
  topUpsCurrentMonth: Maybe<Scalars['Int']['output']>;
};

export type SwissbitCloudBillingTseHealthState = 'DEFECT' | 'STARTED' | 'STARTING' | 'STOPPED';

export type SwissbitCloudBillingTseInitializationState =
  | 'DISABLED'
  | 'INITIALIZED'
  | 'UNINITIALIZED';

export type SwissbitCloudBillingTseUsageItem = {
  __typename: 'SwissbitCloudBillingTseUsageItem';
  autoTopUps: Maybe<Scalars['Int']['output']>;
  productType: Scalars['String']['output'];
  tseSerialNumber: Scalars['String']['output'];
};

export type SwissbitCloudBillingTseVendorItem = {
  __typename: 'SwissbitCloudBillingTseVendorItem';
  productType: Scalars['String']['output'];
  tseSerialNumber: Scalars['String']['output'];
};

export type SwissbitCloudPosAsyncJobStatus = 'FAILURE' | 'PENDING' | 'SUCCESS';

export type SwissbitCloudPosCreditTokenInfo = {
  __typename: 'SwissbitCloudPOSCreditTokenInfo';
  remainingTses: Scalars['Int']['output'];
  state: SwissbitCloudPosCreditTokenState;
  validProductTypes: Array<Scalars['String']['output']>;
};

export type SwissbitCloudPosCreditTokenState = 'ACTIVE' | 'TERMINATED';

export type SwissbitCloudPosExportStatusResponse = {
  __typename: 'SwissbitCloudPOSExportStatusResponse';
  createdAt: Scalars['Int']['output'];
  downloadUrl: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<SwissbitCloudPosExportStatusResponseErrorCodeEnum>;
  errorMessage: Maybe<Scalars['String']['output']>;
  filename: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: SwissbitCloudPosAsyncJobStatus;
};

export type SwissbitCloudPosExportStatusResponseErrorCodeEnum =
  | 'EINTERNALSERVERERROR'
  | 'ETSEDISABLED';

export type SwissbitCloudPosInfoResponse = {
  __typename: 'SwissbitCloudPOSInfoResponse';
  certificateChain: Scalars['String']['output'];
  certificateExpirationDate: Scalars['Int']['output'];
  certificationId: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  createdSignatures: Scalars['Int']['output'];
  creditClientId: Scalars['String']['output'];
  deactivatedAt: Maybe<Scalars['Int']['output']>;
  healthState: SwissbitCloudPosTseHealthState;
  initializationState: SwissbitCloudPosTseInitializationState;
  logTimeFormat: Scalars['String']['output'];
  maxRegisteredClients: Scalars['Int']['output'];
  maxStartedTransactions: Scalars['Int']['output'];
  maxUpdateDelay: Scalars['Int']['output'];
  metadata: Scalars['String']['output'];
  numRegisteredClients: Scalars['Int']['output'];
  numStartedTransactions: Scalars['Int']['output'];
  productType: Scalars['String']['output'];
  productTypeUsage: SwissbitCloudPosProductTypeUsage;
  publicKey: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  signatureAlgorithm: Scalars['String']['output'];
  softwareVersion: Scalars['String']['output'];
  storageCapacity: Scalars['Int']['output'];
  storageUsed: Scalars['Int']['output'];
  timeUntilNextSelfTest: Scalars['Int']['output'];
};

export type SwissbitCloudPosProductTypeMode = 'SLOWDOWN' | 'TOP_UP' | 'UNLIMITED';

export type SwissbitCloudPosProductTypeUsage = {
  __typename: 'SwissbitCloudPOSProductTypeUsage';
  billingPeriodMonths: Scalars['Int']['output'];
  mode: SwissbitCloudPosProductTypeMode;
  signatureDuration: Scalars['Int']['output'];
  signatureLimit: Maybe<Scalars['Int']['output']>;
  signaturesCurrentMonth: Scalars['Int']['output'];
  signaturesRemainingUntilNextLimit: Maybe<Scalars['Int']['output']>;
  slowdownActive: Maybe<Scalars['Boolean']['output']>;
  slowdownActiveSignatureDuration: Maybe<Scalars['Int']['output']>;
  slowdownInactiveSignatureDuration: Maybe<Scalars['Int']['output']>;
  topUpAmount: Maybe<Scalars['Int']['output']>;
  topUpsCurrentMonth: Maybe<Scalars['Int']['output']>;
};

export type SwissbitCloudPosQueryTseCreationStatusResponse = {
  __typename: 'SwissbitCloudPOSQueryTseCreationStatusResponse';
  errorCode: Maybe<SwissbitCloudPosQueryTseCreationStatusResponseErrorCodeEnum>;
  errorMessage: Maybe<Scalars['String']['output']>;
  status: SwissbitCloudPosAsyncJobStatus;
  tseAccessToken: Maybe<Scalars['String']['output']>;
  tseSerialNumber: Maybe<Scalars['String']['output']>;
};

export type SwissbitCloudPosQueryTseCreationStatusResponseErrorCodeEnum =
  | 'EINTERNALSERVERERROR'
  | 'ENOFREEWORKERS';

export type SwissbitCloudPosStartExportResponse = {
  __typename: 'SwissbitCloudPOSStartExportResponse';
  id: Scalars['String']['output'];
};

export type SwissbitCloudPosTseHealthState = 'DEFECT' | 'STARTED' | 'STARTING' | 'STOPPED';

export type SwissbitCloudPosTseInitializationState = 'DISABLED' | 'INITIALIZED' | 'UNINITIALIZED';

export type SwissbitTseReconciliationStatus = 'CANCELLED' | 'NONE' | 'OK' | 'PROBLEM' | 'UNMATCHED';

export type SwissbitTseVendorStatus = 'ACTIVE' | 'CREATED' | 'DEACTIVATED';

export type SwissbitUsageReportDashboardResponse = {
  __typename: 'SwissbitUsageReportDashboardResponse';
  activeTses: Array<SwissbitUsageReportTseRow>;
  createdTses: Array<SwissbitUsageReportTseRow>;
  deactivatedTses: Array<SwissbitUsageReportTseRow>;
};

export type SwissbitUsageReportTseRow = {
  __typename: 'SwissbitUsageReportTseRow';
  autoTopUps: Maybe<Scalars['Int']['output']>;
  daysUntilExpiry: Maybe<Scalars['Int']['output']>;
  matchedLicenceSerials: Array<Scalars['String']['output']>;
  organizationUnitId: Maybe<Scalars['UUID']['output']>;
  organizationUnitName: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
  reconciliationStatus: SwissbitTseReconciliationStatus;
  subscriptionExpiryDate: Maybe<Scalars['DateTime']['output']>;
  subscriptionId: Maybe<Scalars['UUID']['output']>;
  subscriptionNumber: Maybe<Scalars['String']['output']>;
  subscriptionState: Maybe<SubscriptionState>;
  tseSerialNumber: Scalars['String']['output'];
  vendorStatus: SwissbitTseVendorStatus;
};

export type SyncStateDetails = {
  __typename: 'SyncStateDetails';
  items: Array<SyncStateItem>;
  rowCount: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
};

export type SyncStateItem = {
  __typename: 'SyncStateItem';
  rowCount: Scalars['Int']['output'];
  syncState: CloudSyncState;
};

export type Terminal = {
  __typename: 'Terminal';
  autoLogout: Maybe<Scalars['Boolean']['output']>;
  btnTemplate: Maybe<BtnTemplate>;
  btnTemplateId: Maybe<Scalars['Int']['output']>;
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  nr: Maybe<Scalars['Int']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  priceGroup: Maybe<Scalars['String']['output']>;
  printerTemplateId: Maybe<Scalars['Int']['output']>;
  promotionTemplateId: Maybe<Scalars['Int']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  vatType: Maybe<Scalars['Int']['output']>;
};

/**
 * Single input type for both create and update terminal operations.
 * For create: DatabaseId and Name are required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type TerminalInput = {
  autoLogout?: InputMaybe<Scalars['Boolean']['input']>;
  btnTemplateId?: InputMaybe<Scalars['Int']['input']>;
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nr?: InputMaybe<Scalars['Int']['input']>;
  priceGroup?: InputMaybe<Scalars['String']['input']>;
  printerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  promotionTemplateId?: InputMaybe<Scalars['Int']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  vatType?: InputMaybe<Scalars['Int']['input']>;
};

export type TerminalPaginatedResult = {
  __typename: 'TerminalPaginatedResult';
  edges: Maybe<Array<EdgeOfTerminal>>;
  nodes: Array<Terminal>;
  pageInfo: PageInfo;
};

export type UpdateOptionNodeInput = {
  databaseId: Scalars['String']['input'];
  defaultPrice?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
  minChoices?: InputMaybe<Scalars['Int']['input']>;
  price_A?: InputMaybe<Scalars['Decimal']['input']>;
  price_B?: InputMaybe<Scalars['Decimal']['input']>;
  price_C?: InputMaybe<Scalars['Decimal']['input']>;
  price_D?: InputMaybe<Scalars['Decimal']['input']>;
  price_E?: InputMaybe<Scalars['Decimal']['input']>;
  price_F?: InputMaybe<Scalars['Decimal']['input']>;
  price_G?: InputMaybe<Scalars['Decimal']['input']>;
  price_H?: InputMaybe<Scalars['Decimal']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UserType =
  | 'ABTEILUNGSLEITER'
  | 'DRIVER'
  | 'KASSIERER_DISCO'
  | 'KEINER'
  | 'KELLNER_DISCO'
  | 'KELLNER_GASTRO'
  | 'MANAGER'
  | 'MITARBEITER'
  | 'OBERKELLNER_DISCO'
  | 'OBERKELLNER_GASTRO'
  | 'SYSTEM';

export type Vat = {
  __typename: 'Vat';
  createdTime: Maybe<Scalars['DateTime']['output']>;
  databaseId: Scalars['UUID']['output'];
  id: Scalars['Int']['output'];
  itemState: Maybe<Scalars['Int']['output']>;
  lastModified: Maybe<Scalars['DateTime']['output']>;
  nr: Maybe<Scalars['String']['output']>;
  posId: Maybe<Scalars['Int']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
  syncState: Maybe<Scalars['Int']['output']>;
  syncTime: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['UUID']['output'];
  value: Maybe<Scalars['Decimal']['output']>;
};

/**
 * Single input type for both create and update VAT operations.
 * For create: DatabaseId is required. TenantId is obtained from JWT claims.
 * For update: Id is required; other fields are applied only when provided.
 */
export type VatInput = {
  databaseId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemState?: InputMaybe<Scalars['Int']['input']>;
  nr?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  syncState?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type VatPaginatedResult = {
  __typename: 'VatPaginatedResult';
  edges: Maybe<Array<EdgeOfVat>>;
  nodes: Array<Vat>;
  pageInfo: PageInfo;
};

export type SendMailMutationVariables = Exact<{
  sendMail: SendMailInput;
}>;

export type SendMailMutation = {
  __typename: 'Mutation';
  sendMail: { __typename: 'OperationResult'; isSuccess: boolean; message: string | null };
};

export type GetSwissbitCreditTokenUsageQueryVariables = Exact<{
  creditClientId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;

export type GetSwissbitCreditTokenUsageQuery = {
  __typename: 'Query';
  swissbitCreditTokenUsage: {
    __typename: 'SwissbitCloudBillingCreditTokenUsageResponse';
    createdTses: Array<{
      __typename: 'SwissbitCloudBillingTseVendorItem';
      tseSerialNumber: string;
      productType: string;
    }>;
    activeTses: Array<{
      __typename: 'SwissbitCloudBillingTseUsageItem';
      tseSerialNumber: string;
      productType: string;
      autoTopUps: number | null;
    }>;
    deactivatedTses: Array<{
      __typename: 'SwissbitCloudBillingTseVendorItem';
      tseSerialNumber: string;
      productType: string;
    }>;
  } | null;
};

export type SwissbitUsageReportTseFieldsFragment = {
  __typename: 'SwissbitUsageReportTseRow';
  tseSerialNumber: string;
  productType: string;
  autoTopUps: number | null;
  vendorStatus: SwissbitTseVendorStatus;
  reconciliationStatus: SwissbitTseReconciliationStatus;
  subscriptionId: string | null;
  subscriptionNumber: string | null;
  subscriptionState: SubscriptionState | null;
  subscriptionExpiryDate: string | null;
  daysUntilExpiry: number | null;
  organizationUnitId: string | null;
  organizationUnitName: string | null;
  matchedLicenceSerials: Array<string>;
};

export type SwissbitUsageReportQueryVariables = Exact<{
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;

export type SwissbitUsageReportQuery = {
  __typename: 'Query';
  swissbitUsageReport: {
    __typename: 'SwissbitUsageReportDashboardResponse';
    createdTses: Array<{
      __typename: 'SwissbitUsageReportTseRow';
      tseSerialNumber: string;
      productType: string;
      autoTopUps: number | null;
      vendorStatus: SwissbitTseVendorStatus;
      reconciliationStatus: SwissbitTseReconciliationStatus;
      subscriptionId: string | null;
      subscriptionNumber: string | null;
      subscriptionState: SubscriptionState | null;
      subscriptionExpiryDate: string | null;
      daysUntilExpiry: number | null;
      organizationUnitId: string | null;
      organizationUnitName: string | null;
      matchedLicenceSerials: Array<string>;
    }>;
    activeTses: Array<{
      __typename: 'SwissbitUsageReportTseRow';
      tseSerialNumber: string;
      productType: string;
      autoTopUps: number | null;
      vendorStatus: SwissbitTseVendorStatus;
      reconciliationStatus: SwissbitTseReconciliationStatus;
      subscriptionId: string | null;
      subscriptionNumber: string | null;
      subscriptionState: SubscriptionState | null;
      subscriptionExpiryDate: string | null;
      daysUntilExpiry: number | null;
      organizationUnitId: string | null;
      organizationUnitName: string | null;
      matchedLicenceSerials: Array<string>;
    }>;
    deactivatedTses: Array<{
      __typename: 'SwissbitUsageReportTseRow';
      tseSerialNumber: string;
      productType: string;
      autoTopUps: number | null;
      vendorStatus: SwissbitTseVendorStatus;
      reconciliationStatus: SwissbitTseReconciliationStatus;
      subscriptionId: string | null;
      subscriptionNumber: string | null;
      subscriptionState: SubscriptionState | null;
      subscriptionExpiryDate: string | null;
      daysUntilExpiry: number | null;
      organizationUnitId: string | null;
      organizationUnitName: string | null;
      matchedLicenceSerials: Array<string>;
    }>;
  } | null;
};

export const SwissbitUsageReportTseFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SwissbitUsageReportTseFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SwissbitUsageReportTseRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'tseSerialNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoTopUps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendorStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reconciliationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionExpiryDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'daysUntilExpiry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matchedLicenceSerials' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwissbitUsageReportTseFieldsFragment, unknown>;
export const SendMailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendMail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendMail' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendMailInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendMail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sendMail' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMailMutation, SendMailMutationVariables>;
export const GetSwissbitCreditTokenUsageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSwissbitCreditTokenUsage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'creditClientId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'month' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'swissbitCreditTokenUsage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'creditClientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'creditClientId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'month' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'month' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdTses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tseSerialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeTses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tseSerialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoTopUps' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deactivatedTses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'tseSerialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSwissbitCreditTokenUsageQuery,
  GetSwissbitCreditTokenUsageQueryVariables
>;
export const SwissbitUsageReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SwissbitUsageReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'month' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'swissbitUsageReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'month' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'month' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdTses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SwissbitUsageReportTseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeTses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SwissbitUsageReportTseFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deactivatedTses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SwissbitUsageReportTseFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SwissbitUsageReportTseFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SwissbitUsageReportTseRow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'tseSerialNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoTopUps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendorStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reconciliationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subscriptionExpiryDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'daysUntilExpiry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'organizationUnitName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matchedLicenceSerials' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwissbitUsageReportQuery, SwissbitUsageReportQueryVariables>;
